import { isArray, isEqual, isObject, union } from 'lodash';
const VALUE_CREATED = 'created';
const VALUE_UPDATED = 'updated';
const VALUE_DELETED = 'deleted';
const VALUE_UNCHANGED = 'unchanged';
function compareValues(value1, value2) {
    if (isEqual(value1, value2)) {
        return {
            type: VALUE_UNCHANGED,
            data: { left: value1, right: value2 },
        };
    }
    if (value1 === undefined) {
        return {
            type: VALUE_CREATED,
            data: { left: value1, right: value2 },
        };
    }
    if (value2 === undefined) {
        return {
            type: VALUE_DELETED,
            data: { left: value1, right: value2 },
        };
    }
    return {
        type: VALUE_UPDATED,
        data: { left: value1, right: value2 },
    };
}
export function deepDiff(obj1, obj2, excludeUnchanged = true) {
    if (isEqual(obj1, obj2) && excludeUnchanged) {
        return null;
    }
    if (!isObject(obj1) && !isArray(obj1)) {
        const diffResult = compareValues(obj1, obj2);
        return excludeUnchanged && diffResult.type === VALUE_UNCHANGED ? null : diffResult;
    }
    if (isArray(obj1) && isArray(obj2)) {
        const maxLength = Math.max(obj1.length, obj2.length);
        const diff = {};
        for (let i = 0; i < maxLength; i++) {
            const valueDiff = deepDiff(obj1[i], obj2[i], excludeUnchanged);
            if (valueDiff !== null) {
                diff[i] = valueDiff;
            }
        }
        return diff;
    }
    if (isObject(obj1) && isObject(obj2)) {
        const allKeys = union(Object.keys(obj1), Object.keys(obj2));
        const diff = {};
        for (const i of allKeys) {
            // @ts-ignore
            const left = i in obj1 ? obj1[i] : undefined;
            // @ts-ignore
            const right = i in obj2 ? obj2[i] : undefined;
            const valueDiff = deepDiff(left, right, excludeUnchanged);
            if (valueDiff !== null) {
                diff[i] = valueDiff;
            }
        }
        return diff;
    }
    if (obj1 === undefined) {
        return {
            type: VALUE_CREATED,
            data: { left: obj1, right: obj2 },
        };
    }
    else if (obj2 === undefined) {
        return {
            type: VALUE_DELETED,
            data: { left: obj1, right: obj2 },
        };
    }
    return {
        type: VALUE_UPDATED,
        data: { left: obj1, right: obj2 },
    };
}
//# sourceMappingURL=debug.js.map